import React, { useEffect } from 'react'
import { Redirect, Route, useHistory, useLocation } from 'react-router-dom'
import { ROUTES } from 'src/constants/routes'
import { delHsToken, getSession, isUserAuthenticated } from 'src/helpers/authUtils'
import { getUriQueriesFromLocation } from 'src/helpers/uri'
import useShallowEqualSelector from 'src/hooks/useShallowEqualSelector'
import { TBrand } from 'src/redux/models/AuthInfo'
import { State } from 'src/redux/reducers'
import { setLoggerUser } from 'src/redux/middleware/dataDogLogger'

type Props = {}

const generateRedirectPath = ({
  isAuthTokenValid,
  currentBrand,
  pathname,
  search
}: {
  isAuthTokenValid: boolean
  currentBrand: TBrand
  pathname: string
  search: string
}) => {
  if (isAuthTokenValid) return ''
  const uriQueries = getUriQueriesFromLocation(pathname)
  const url = encodeURIComponent(pathname + search)
  const brandId = uriQueries.brandId.length > 0 ? uriQueries.brandId : currentBrand.id
  if (['/', '/signout'].includes(pathname)) return `${ROUTES.signIn()}`
  return `${ROUTES.signIn()}?brandId=${brandId}&redirectTo=${url}`
}

const Authenticate: React.FC<Props> = ({ children }) => {
  const location = useLocation()
  const { user } = useShallowEqualSelector((state: State) => state.Auth).toObject()
  const organizationId = user?.toObject()?.organizationId
  const { id, lastName, firstName, email } = user?.toObject().user.toObject()
  const currentBrand = user.toObject().currentBrand.toObject()
  const isAuthTokenValid = isUserAuthenticated(getSession('user'))
  const isTopPage = location.pathname === '/'
  const history = useHistory()
  useEffect(() => {
    if (!isAuthTokenValid) {
      delHsToken()
    }
    if (isAuthTokenValid) {
      setLoggerUser({
        id: id.toString(),
        name: `${lastName}${firstName}`,
        email,
        brandId: currentBrand.id,
        brandName: currentBrand.displayName
      })
      // (どこの組織にも属していない && `/` ページ(組織ダッシュボード)にアクセス) -> 通常のダッシュボードページへ遷移
      if (!organizationId && isTopPage) {
        history.replace(`${ROUTES.brandTop(`${currentBrand.id}`)}`)
      }
    }
  }, [currentBrand, email, firstName, history, id, isAuthTokenValid, isTopPage, lastName, location, organizationId])

  const redirectPath = generateRedirectPath({ isAuthTokenValid, currentBrand, ...location })
  return isAuthTokenValid ? <Route>{children}</Route> : <Redirect to={redirectPath} from={location.pathname} />
}

export default Authenticate
